import React from 'react';

import { Select } from './Select';
import countries from './countries.json';
import { getTranslatedString } from 'helpers/i18n';

let options = countries.map(country => {
  return {
    value: country.code,
    // label: country.name,
    label: getTranslatedString(`country.${country.code}`),
  };
});
options = [{ value: '', label: getTranslatedString('selectCountries.selectCountry') }].concat(
  options
);

export const SelectCountries = props => {
  return <Select options={options} {...props} />;
};
